import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params = null, callbackSuccess = null, callbackFinally) => {
    return AppModel.get(
      'delivered/images',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        if (callbackSuccess !== null) {
          callbackSuccess(res.data)
        }

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  postApi: (bvModal, params, callbackSuccess = null, callbackFinally) => {
    return AppModel.post(
      'delivered/images',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        if (callbackSuccess !== null) {
          callbackSuccess(res.data)
        }

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  uploadApi: (bvModal, params, callbackSuccess = null, callbackFinally) => {
    return AppModel.post(
      'delivered/image/upload',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        if (callbackSuccess !== null) {
          callbackSuccess(res.data)
        }

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  putApi: (bvModal, params, callbackSuccess = null, callbackFinally) => {
    return AppModel.put(
      'delivered/images',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        if (callbackSuccess !== null) {
          callbackSuccess(res.data)
        }

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  deleteApi: (bvModal, params = null, callbackFinally) => {
    return AppModel.delete(
      'delivered/images',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('plan', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/DeliveredImageModel.js